import { Fertilizer } from "@/store/modules"
import FertilizerAPI from "@/api/FertilizerAPI"

const state = {
  fertilizers: [],
}

const getters = {
  [Fertilizer.Getters.getFertilizers]: state => state.fertilizers,
}

const mutations = {
  [Fertilizer.Mutations.setFertilizers](state, ferts) {
    // adding for v-select dropdowns
    ferts.forEach(f => {
      f["display_name"] = f["fert_shorthands"][0]
      f["value"] = f["fert_name"]
    })
    state.fertilizers = ferts
  },
}

const actions = {
  [Fertilizer.Actions.fetchFertilizers]({ commit }) {
    return new Promise(resolve => {
      FertilizerAPI.listAllFertilizer().then(response => {
        const sortedFerts = response.data.sort((a, b) => a.fert_shorthands[0].length - b.fert_shorthands[0].length)
        // Deal with historical duplicates
        const uniqueFerts = sortedFerts.filter((fert, index, array) =>
          array.findIndex(f => f.fert_shorthands[0] === fert.fert_shorthands[0]) === index
        )
        // filter out dropdown-excluded ferts
        const dropdownFerts = uniqueFerts.filter(f => !f.show_in_dropdown)
        commit(Fertilizer.Mutations.setFertilizers, dropdownFerts)
        resolve()
      })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
